class cartUpsell extends HTMLElement {
    constructor() {
      super();
     
      this.init();

      document.addEventListener('upsell:init', () => {
        this.init.bind(this);
      });
    };

    init() {
        this.addEventListener("click", function() {
            const id = this.dataset.variantId;

            this.classList.add("btn-loading");
            this.addToCart(id);
        })
    };

    addToCart(id) {
        const data = {
            items: [
                {
                    id,
                    quantity: 1
                }
            ]
        };

        fetch('/cart/add.js', {
            body: JSON.stringify(data),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
            },
            method: 'POST'
          }).then(function(response) {
            return response.json();
          }).then( () => {
            this.classList.remove("btn-loading");
            document.dispatchEvent(new CustomEvent('cart:build'));
          })
    }
}
  
customElements.define('cart-upsell', cartUpsell);
  
  